import React from 'react';
import '../blocks/ModernBlocks.css';

const ValuesBlock = ({ data }) => {
  return (
    <section className="values-section">
      <div className="values-container">
        <div className="values-header">
          <h2 className="values-title">{data.title}</h2>
          <p className="values-subtitle">{data.subtitle}</p>
        </div>
        <div className="values-grid">
          {data.items.map((value, index) => (
            <div key={index} className="value-card">
              <div 
                className="value-icon"
                style={{ backgroundColor: value.color + '20', color: value.color }}
              >
                {value.icon}
              </div>
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesBlock; 